import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMipsEligibility from '@store/reducers/mips-eligibility/mips-eligibility.reducer';

export const selectMipsEligibilityState = createFeatureSelector<fromMipsEligibility.State>(
  fromMipsEligibility.mipsEligibilityFeatureKey
);

export const selectEligibilityResult = createSelector(
  selectMipsEligibilityState,
  (state: fromMipsEligibility.State) => state.eligibilityResult
);

export const selectMvpRegistered = createSelector(
  selectEligibilityResult,
  (result) => result?.mvpRegistered ?? false
);

export const selectMvpId = createSelector(
  selectEligibilityResult,
  (result) => result?.mvpId ?? null
);

export const selectIsCheckingEligibility = createSelector(
  selectMipsEligibilityState,
  (state: fromMipsEligibility.State) => state.isCheckingEligibility
);

export const selectEligibilityError = createSelector(
  selectMipsEligibilityState,
  (state: fromMipsEligibility.State) => state.eligibilityError
);

export const selectBatchEligibilityResults = createSelector(
  selectMipsEligibilityState,
  (state: fromMipsEligibility.State) => state.batchEligibilityResults
);

export const selectIsCheckingBatch = createSelector(
  selectMipsEligibilityState,
  (state: fromMipsEligibility.State) => state.isCheckingBatch
);

export const selectBatchError = createSelector(
  selectMipsEligibilityState,
  (state: fromMipsEligibility.State) => state.batchError
);